import { useRef } from "react";

// How to use:
// -First, create data within helpers.js as "const pageLockData".
// -Then, within the wrapper component(ex: Form9142AWrapper.js):
// 1. Call this hook in top level: "const pageLock = usePageLock(pageLockData);"
// 2. Pass prop through SimpleForm component: pageLock={pageLock}
export const usePageLock = ({ lockedPage, requiredFields }) => {
  const hasRequiredFields =
    Array.isArray(requiredFields) &&
    requiredFields?.length > 0 &&
    requiredFields !== undefined &&
    requiredFields !== null;
  const isLocked = useRef(hasRequiredFields && lockedPage ? true : false);

  const handlePageLock = (form) => {
    let new_lock_status = false;

    if (hasRequiredFields) {
      requiredFields.forEach((field) => {
        let { invalid } = { ...form?.getFieldState(field) };
        if (invalid === true) {
          new_lock_status = true;
        }
      });
    }
    isLocked.current = new_lock_status;
  };

  return {
    isLocked,
    lockedPage,
    handlePageLock,
  };
};
